import React from 'react';
import { Link } from 'react-router-dom';
import { getAllCategories } from '../config/magazineConfig';

const HomePage = () => {
  const categories = getAllCategories();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      {/* Header con diseño mejorado */}
      <header className="app-header relative overflow-hidden">
        {/* Efecto de fondo decorativo */}
        <div className="absolute inset-0 bg-gradient-to-r from-red-700 via-red-600 to-red-500 opacity-90"></div>
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '16px'
          }}>
            {/* Logo con efecto */}
            <div style={{ flexShrink: 0 }} className="transform hover:scale-105 transition-transform">
              <img
                src={`${process.env.PUBLIC_URL}/logo/logo.svg`}
                alt="Logo"
                className="app-logo"
                style={{ height: '56px', filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            {/* Título mejorado */}
            <div>
              <h1 
                style={{
                  color: '#ffffff',
                  fontSize: '32px',
                  fontWeight: '800',
                  margin: '0',
                  letterSpacing: '0.5px',
                  textShadow: '0 2px 8px rgba(0,0,0,0.3)'
                }}
              >
                Centro de Publicaciones
              </h1>
              <p style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '15px',
                margin: '6px 0 0 0',
                fontWeight: '400',
                textShadow: '0 1px 2px rgba(0,0,0,0.2)'
              }}>
                Explora nuestras publicaciones digitales interactivas
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content con animaciones */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-10 text-center">
          <h2 className="text-3xl font-bold bg-gradient-to-r from-red-700 to-red-500 bg-clip-text text-transparent mb-3">
            Categorías de Publicaciones
          </h2>
          <p className="text-gray-600 text-lg">
            Selecciona una categoría para explorar las publicaciones disponibles
          </p>
        </div>

        {/* Lista de categorías con diseño premium */}
        {categories.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-lg p-12 text-center border border-gray-100">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full mb-6">
              <svg 
                className="h-8 w-8 text-blue-600 flex-shrink-0" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              No hay categorías disponibles
            </h3>
            <p className="text-gray-500 text-base">
              Agrega categorías en el archivo de configuración para comenzar
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category, index) => (
              <Link
                key={category.id}
                to={`/${category.id}`}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2 border border-gray-100"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Header de la tarjeta con gradiente */}
                <div className="relative h-40 bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 overflow-hidden">
                  {/* Icono de categoría flotante */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div className="flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <svg 
                        className="w-8 h-8 text-white flex-shrink-0" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path 
                          strokeLinecap="round" 
                          strokeLinejoin="round" 
                          strokeWidth={2} 
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" 
                        />
                      </svg>
                    </div>
                  </div>
                  {/* Badge con cantidad de publicaciones */}
                  <div className="absolute top-4 right-4">
                    <span className="inline-flex items-center px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-bold text-purple-700 shadow-lg">
                      {category.magazines.length} {category.magazines.length === 1 ? 'publicación' : 'publicaciones'}
                    </span>
                  </div>
                </div>

                {/* Contenido de la tarjeta */}
                <div className="p-6">
                  {/* Título */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-purple-600 group-hover:bg-clip-text transition-all">
                    {category.name}
                  </h3>

                  {/* Descripción */}
                  <p className="text-sm text-gray-600 mb-5 line-clamp-2 leading-relaxed">
                    {category.description}
                  </p>

                  {/* Botón de acción */}
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <span className="text-blue-600 font-semibold text-sm group-hover:text-purple-600 transition-colors">
                      Explorar publicaciones
                    </span>
                    <svg 
                      className="w-4 h-4 text-blue-600 group-hover:text-purple-600 group-hover:translate-x-1 transition-all flex-shrink-0" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M13 7l5 5m0 0l-5 5m5-5H6" 
                      />
                    </svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* Instrucciones mejoradas */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200 rounded-2xl p-8 shadow-md">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl">
                <svg 
                  className="w-5 h-5 text-white flex-shrink-0" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                  />
                </svg>
              </div>
            </div>
            <div className="ml-5 flex-1">
              <h4 className="text-lg font-bold text-gray-900 mb-3">
                ¿Cómo agregar más publicaciones?
              </h4>
              <ol className="text-sm text-gray-700 space-y-2">
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-6 h-6 bg-blue-600 text-white rounded-full text-xs font-bold mr-3 flex-shrink-0 mt-0.5">1</span>
                  <span>Sube el archivo PDF a la carpeta <code className="bg-white px-2 py-1 rounded border border-blue-200 font-mono text-xs">public/pdfs/</code></span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-6 h-6 bg-blue-600 text-white rounded-full text-xs font-bold mr-3 flex-shrink-0 mt-0.5">2</span>
                  <span>Edita el archivo <code className="bg-white px-2 py-1 rounded border border-blue-200 font-mono text-xs">src/config/magazineConfig.js</code></span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-6 h-6 bg-blue-600 text-white rounded-full text-xs font-bold mr-3 flex-shrink-0 mt-0.5">3</span>
                  <span>Agrega la publicación en el array magazines de su categoría correspondiente</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </main>

      {/* Footer mejorado */}
      <footer className="mt-20 border-t border-gray-200 bg-white/50 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <p className="text-center text-gray-600 text-sm">
            © {new Date().getFullYear()} Centro de Publicaciones • Todos los derechos reservados
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
